import AddContactDetails from "./addContactDetails";
import POAInfo from "./poaInfo";
import POADuration from "./poaDuration";
import POASign from "./poaSign";
import POABankID from "./poaBankID";
import AdvisoryBooking from "./advisoryBooking";
import CustomerSummary from "./customerSummary";
import CustomerPoaConfirmation from "./confirmation";
import POAStepper from "../poaStepper";
import { Identify } from "./identify";
import { usePOAStepsStore } from "../../hooks/ui/";
import { ENUMPOASteps } from "../../hooks/ui/poaStepsDataStore";
import { Dispatch, SetStateAction } from "react";
import { Box } from "@mantine/core";

const POASteps = ({
  setUserCancelled,
  renewal = false,
  setHandleDone,
}: {
  setUserCancelled: Dispatch<SetStateAction<boolean>>;
  renewal?: boolean;
  setHandleDone?: () => void;
}) => {
  const { currentStep } = usePOAStepsStore();

  let renderStep;

  if (renewal) {
    renderStep = () => {
      switch (currentStep) {
        case ENUMPOASteps.POAINFO:
          return <POAInfo onBack={() => setUserCancelled(true)} />;
        case ENUMPOASteps.POADURATION:
          return <POADuration />;
        case ENUMPOASteps.POACONFIRMATION:
          return <POASign />;
        case ENUMPOASteps.POASIGN:
          return <POABankID />;
        case ENUMPOASteps.CONFIRMATION:
          return <CustomerPoaConfirmation setHandleDone={setHandleDone} />;
        default:
          return null;
      }
    };
  } else {
    renderStep = () => {
      switch (currentStep) {
        case ENUMPOASteps.IDENTIFY:
          return <Identify setUserCancelled={setUserCancelled} />;
        case ENUMPOASteps.EMAILANDPHONE:
          // Back to the welcome screen, not a fresh BankID identification.
          return <AddContactDetails onBack={() => setUserCancelled(true)} />;
        case ENUMPOASteps.POAINFO:
          return <POAInfo />;
        case ENUMPOASteps.POADURATION:
          return <POADuration />;
        case ENUMPOASteps.POACONFIRMATION:
          return <POASign />;
        case ENUMPOASteps.POASIGN:
          return <POABankID />;
        case ENUMPOASteps.BOOKMEETING:
          return <AdvisoryBooking />;
        case ENUMPOASteps.POASUMMARY:
          return <CustomerSummary />;
        default:
          return null;
      }
    };
  }

  return (
    <Box>
      {currentStep !== ENUMPOASteps.POASUMMARY && (
        <POAStepper renewal={renewal} />
      )}
      {renderStep()}
    </Box>
  );
};

export default POASteps;
